module.exports = __webpack_public_path__ + "img/vip_cashout.e73541df.png";